// removed by extract-text-webpack-plugin
module.exports = {"root":"_2ItplEXWNPJd6fKCn5rE7J","content":"_2wmzVv4yZfAnNeNPWARFja","bar-item":"_3g-mcfrdXwCYg6kIg4wS84","label":"_1wT75SVLiFtTILm6oHGX6C","media":"xopmh8qbjsTcgIdEYw-do","see-more":"X_Th5FJrB2Krp2yjpvitX","pie":"_1-u3zhIuqrYpFeRL5K07vM","bar":"_1XhnFZSI4c3PDqrKK74xH1","word-cloud":"jbJa9l0F-VnUNObIIAfCC","number-of-responses":"hZ5eVTJRgEahAkFurFjsD","audience":"_1EYqacasstuB5pQ91WFGcP","audience-item":"dXAZRCay0zd5Fm13Qa233","average":"_1gBU7zzC-O_vXSfnL83ehR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/insight.scss
// module id = 1327
// module chunks = 0